// Smithing table screen (M59). Like the enchanting table it works on the item in
// HAND: it names the upgrade that item is eligible for, what the re-forge costs,
// and forges it. Client-only (ENG-1).
import { h, clear } from '../h';
import type { Game } from '../../boot';

const pretty = (name: string): string => name.replace(/_/g, ' ');

export function openSmithing(game: Game): void {
  game.uiOpen = true;
  document.exitPointerLock();

  const overlay = h('div', { class: 'bb-window-overlay' });
  const panel = h('div', { class: 'bb-window', style: { minWidth: '340px' } });
  overlay.append(panel);
  document.body.append(overlay);

  const render = (): void => {
    clear(panel);
    panel.append(h('div', { class: 'bb-window-title' }, 'Smithing'));
    const offer = game.smithingOffer();
    if (!offer) {
      panel.append(h('div', { style: { opacity: '0.7', padding: '8px 0' } },
        'Hold a diamond tool or piece of armour to upgrade it.'));
    } else {
      panel.append(h('div', { style: { margin: '4px 0 10px' } },
        `${pretty(offer.base)}  →  ${pretty(offer.result)}`));
      const cost = [offer.template, offer.addition].filter(Boolean).map((n) => pretty(n!)).join(' + ');
      const row = h('button', {
        class: 'bb-btn',
        type: 'button',
        'data-slot': 'smith-0',
        style: {
          display: 'flex', width: '100%', gap: '10px', alignItems: 'center', margin: '4px 0',
          textAlign: 'left', opacity: offer.affordable ? '1' : '0.5',
        },
      },
        h('span', { style: { flex: '1' } }, `Forge — ${cost}`),
        h('span', { style: { opacity: '0.85', whiteSpace: 'nowrap' } }, offer.affordable ? 'ready' : 'missing'));
      row.addEventListener('mousedown', (e) => { e.preventDefault(); if (game.doSmith()) render(); });
      panel.append(row);
    }

    const close = h('button', { class: 'bb-btn', type: 'button', style: { marginTop: '10px' } }, 'Close');
    close.addEventListener('mousedown', (e) => { e.preventDefault(); doClose(); });
    panel.append(close);
  };

  let closed = false;
  const doClose = (): void => {
    if (closed) return;
    closed = true;
    document.removeEventListener('keydown', onKey, true);
    overlay.remove();
    game.uiOpen = false;
    void game.renderer.domElement.requestPointerLock();
  };
  const onKey = (e: KeyboardEvent): void => {
    if (e.code === 'Escape' || e.code === 'KeyE') { e.preventDefault(); e.stopPropagation(); doClose(); }
  };
  document.addEventListener('keydown', onKey, true);
  overlay.addEventListener('mousedown', (e) => { if (e.target === overlay) doClose(); });
  render();
}
